import { JsonSchemaPianificazionePropertiesFormProperties } from "./campaign-3.model";

export class CouponProductsTargetForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaPianificazionePropertiesFormProperties;
}

export class CertificationTouchpointList{
  certifiedTouchpoint: Array<CertificationTouchpoint>;
  notCertifiedTouchpoint: Array<CertificationTouchpoint>;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;

  constructor(){
    this.certifiedTouchpoint = [];
    this.notCertifiedTouchpoint = [];
  }
}

export class CertificationTouchpoint{
  touchpointId: number;
  touchpointCode: string;
  touchpointDescription: string;
  promoClass: string;
  variantType: string;
  status: string;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3-validation.model.ts